export default __webpack_public_path__ + "static/media/1.5012aa21.jpg";